var map = {
	"../pages/admin-vaccine/admin-vaccine.module": [
		"../../../../../src/app/pages/admin-vaccine/admin-vaccine.module.ts"
	],
	"../pages/change-password/change-password.module": [
		"../../../../../src/app/pages/change-password/change-password.module.ts"
	],
	"../pages/information/information.module": [
		"../../../../../src/app/pages/information/information.module.ts"
	],
	"../pages/request-appointment/request-appointment.module": [
		"../../../../../src/app/pages/request-appointment/request-appointment.module.ts"
	],
	"../pages/update-patient-information/update-patient-information.component.module": [
		"../../../../../src/app/pages/update-patient-information/update-patient-information.component.module.ts"
	],
	"../pages/view-invoices/view-invoices.module": [
		"../../../../../src/app/pages/view-invoices/view-invoices.module.ts"
	],
	"../pages/view-medical-conditions/view-medical-conditions.module": [
		"../../../../../src/app/pages/view-medical-conditions/view-medical-conditions.module.ts",
		"view-medical-conditions.module"
	],
	"../pages/view-prescriptions/view-prescriptions.module": [
		"../../../../../src/app/pages/view-prescriptions/view-prescriptions.module.ts"
	],
	"../pages/view-schedule/vaccination.module": [
		"../../../../../src/app/pages/view-schedule/vaccination.module.ts"
	],
	"../pages/view-schedule/view-schedule.module": [
		"../../../../../src/app/pages/view-schedule/view-schedule.module.ts"
	],
	"../pages/view-uploaded-documents/view-uploaded-documents.module": [
		"../../../../../src/app/pages/view-uploaded-documents/view-uploaded-documents.module.ts"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// D:/TMB/TMB/MYTMB.UI/src/$$_gendir lazy
// module id = ../../../../../src/$$_gendir lazy recursive
// module chunks = main